module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8n5n1n-25e4957e2b446558993313ef214f7de1.svg";